<template>
  <el-card>
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        @reset="reset"
        slot="header"
        @submit="handleSubmit"
        ref="header"
      />
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      />
    </page-main>
  </el-card>
</template>

<script>
export default {
  components: {
    PageHeader: () => import('./header'),
    PageMain: () => import('./main'),
  },
  data() {
    return {
      table: [],
      loading: false,
      page: {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0,
      },
    }
  },
  methods: {
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 20,
        pageTotal: 0,
      }
    },
    // 重载表格数据
    reload() {
      this.$nextTick(() => {
        this.$refs.header.query()
      })
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true
      this.$api
        .myVisitListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.table = res.body.data
          if (this.table === null) {
            this.isEmpty = true
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
